import { Station } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { StationLabel } from './StationLabel';

interface Props {
  data: readonly Station[];
}

export const AdminStationsList = (props: Props) => {
  const { formatMessage } = useIntl();
  const { data } = props;

  return (
    <MrtTable
      navigateToOnClick={(id, row) => `/admin/stations/${row.slug}`}
      enableNavigateAction
      enableColumnFilters
      columnFilterDisplayMode="subheader"
      state={{
        showColumnFilters: true,
      }}
      columns={[
        {
          header: formatMessage({
            id: 'common.text.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableColumnFilter: true,
          muiFilterTextFieldProps: {
            sx: {
              maxWidth: '250px',
            },
          },
          Cell: ({ row: { original } }) => <StationLabel station={original} />,
        },
      ]}
      data={[...data]}
    />
  );
};
